import React, { useState } from 'react';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import { connect } from 'react-redux';

import InformationStep from './InformationStep';
import { actions as reduxActions } from '../reducers';
import SubscriptionStep from './SubscriptionStep';
import { isStringEmpty, isStringDefined } from '../../../utils/isDefined';
import CustomStepperStepIcon from '../../../partials/CustomStepperStepIcon/CustomStepperStepIcon';
import AddressStep from './AddressStep';
import { translate } from '../../../i18n/I18nProvider';
import PhoneNumbers from './PhoneNumbers';
import PortNumberStep from './PortNumberStep';

const UserStepper = ({
  selected,
  sendSimcard,
  mobile_number,
  onFirstStepDirtyChange,
  onCloseAttempt
}) => {
  const ALL_STEPS = [
    translate('REQUEST_NEW_USER.INFORMATION_STEP'),
    translate('PHONE_NUMBERS'),
    translate('REQUEST_NEW_USER.PORT_NUMBER_STEP'),
    translate('REQUEST_NEW_USER.SUBSCRIPTION_STEP'),
    sendSimcard
      ? `${translate('ADDRESS')}/${translate('ACTIVATION_DATE')}`
      : `${translate('ACTIVATION_DATE')}`
  ];
  const isPort = selected === 'port';
  const hasMobileNumber = isStringDefined(mobile_number);

  const hiddenIndices = new Set();
  if (!isPort) hiddenIndices.add(2);
  if (!hasMobileNumber) hiddenIndices.add(3);
  const STEPS = ALL_STEPS.filter((_, i) => !hiddenIndices.has(i));

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = (step = 1) => {
    return setActiveStep(prevActiveStep => prevActiveStep + step);
  };

  const handleBack = (step = 1) => {
    return setActiveStep(prevActiveStep => prevActiveStep - step);
  };

  let displayActiveStep = activeStep;
  if (!isPort && activeStep >= 3) displayActiveStep--;
  if (!hasMobileNumber && activeStep >= 4) displayActiveStep--;

  return (
    <>
      <Stepper activeStep={displayActiveStep} alternativeLabel>
        {STEPS.map(label => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepperStepIcon}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {getStepContent(
          activeStep,
          handleNext,
          handleBack,
          onFirstStepDirtyChange,
          onCloseAttempt
        )}
      </div>
    </>
  );
};

const mapStatesToProps = ({ requestUserWizard }) => {
  return {
    isMobileNumberProvided: !isStringEmpty(
      requestUserWizard.userData.firstStep.mobile_number
    ),
    selected: requestUserWizard.userData.secondStep.selected,
    mobile_number: requestUserWizard.userData.secondStep.mobile_number,
    sendSimcard:
      requestUserWizard.userData?.fourthStep?.send_sim_card === true ||
      requestUserWizard.userData.fourthStep.send_sim_card_sharing === true
  };
};

const mapDispatchToProps = {
  resetWizard: reduxActions.resestUserWizard
};

export default connect(mapStatesToProps, mapDispatchToProps)(UserStepper);

const getStepContent = (
  stepIndex,
  handleNext,
  handleBack,
  onFirstStepDirtyChange,
  onCloseAttempt
) => {
  switch (stepIndex) {
    case 0:
      return (
        <InformationStep
          handleNext={step => handleNext(step)}
          onFirstStepDirtyChange={onFirstStepDirtyChange}
          onCloseAttempt={onCloseAttempt}
        />
      );
    case 1:
      return (
        <PhoneNumbers
          handleNext={handleNext}
          handleBack={handleBack}
          onCloseAttempt={onCloseAttempt}
        />
      );
    case 2:
      return (
        <PortNumberStep
          handleNext={handleNext}
          handleBack={handleBack}
          onCloseAttempt={onCloseAttempt}
        />
      );
    case 3:
      return (
        <SubscriptionStep
          handleBack={handleBack}
          handleNext={handleNext}
          onCloseAttempt={onCloseAttempt}
        />
      );
    case 4:
      return (
        <AddressStep handleBack={handleBack} onCloseAttempt={onCloseAttempt} />
      );
    default:
      return 'Unknown stepIndex';
  }
};
